import { FC, memo } from 'react'

import { DateTime, IconName, Link, Table } from 'ui/components'

import { ConnectedIcon, NoConnectedIcon } from '../../../../styles'
import * as SC from '../../styles'
import { ConnectionsDetailsConnection } from '../../types'

type Props = {
  connections: ConnectionsDetailsConnection[]
}

export const ConnectionsTable: FC<Props> = memo((props) => {
  const { connections } = props

  // place current connection to the first position in the array (by design)
  const currentConnectionIndex = connections.findIndex((e) => e.current)
  if (currentConnectionIndex !== -1) {
    const a = connections[currentConnectionIndex]
    connections[currentConnectionIndex] = connections[0]
    connections[0] = a
  }

  return (
    <Table<ConnectionsDetailsConnection>
      columns={[
        {
          width: '24px',
          align: 'center',
          title: '',
          render: ({ current }) => current && <SC.CurrentLicenseIcon name={IconName.STAR} />
        },
        {
          title: 'License',
          align: 'left',
          render: (item) => (
            <Link to="/licenses/$licenseId" params={{ licenseId: item.licenseId.toString() }}>
              {item.licenseName} ({item.licenseNumber})
            </Link>
          )
        },
        {
          title: 'Connection',
          align: 'center',
          render: ({ isConnected }) => (
            <>
              {isConnected ? (
                <ConnectedIcon name={IconName.CHECK_ROUND} />
              ) : (
                <NoConnectedIcon name={IconName.CROSS_ROUND} />
              )}
            </>
          )
        },
        {
          title: 'Relationship',
          align: 'left',
          render: (item) => (
            <Link to="/relationships/$id" params={{ id: item.relationshipId.toString() }}>
              {item.relationshipName}
            </Link>
          )
        },
        {
          key: 'lastUpdatedAt',
          title: 'Last update',
          align: 'left',
          render: ({ lastUpdatedAt }) => <DateTime date={lastUpdatedAt} withTime />
        }
      ]}
      dataSource={connections.map((el) => ({ item: el }))}
      dataQa={'connections'}
    />
  )
})
